<template>
  <validation-observer tag="div" class="vx-form-wrapper" v-slot="form" ref="form">
    <slot v-bind="form" />
  </validation-observer>
</template>
<script>
import { ValidationObserver } from 'vee-validate'
export default {
  name: 'vx-form',
  inheritAttrs: false,
  props: {
    layout: {
      type: String,
      default: 'h'
    },
    labelSplit: {
      type: String,
      default: 'sm:w-1/4'
    },
    labelAlign: {
      type: String,
      default: 'top'
    },
    wrapSplit: {
      type: String,
      default: 'sm:w-1/2'
    }
  },
  components: {
    ValidationObserver,
  },
  computed: {
    form() {
      return this.$refs.form
    }
  },
  methods: {
    validate(...args) {
      return this.form.validate(...args).then(res => {
        if (!res) {
          throw new Error('has error')
        }
      })
    },
    handlerSubmit(fn) {

    }
  },
}
</script>